import React, { useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { ProgereBrand } from "@/components/ProgereBrand";
import { ShieldCheck, KeyRound } from "lucide-react";

export default function InternalLoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [code, setCode] = useState("");
  const [needCode, setNeedCode] = useState(false);
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    if (!email || !password) { toast.error("Courriel et mot de passe requis"); return; }
    setSaving(true);
    try {
      const { data } = await api.post("/platform/internal-login", { email, password, code: code || undefined });
      if (data.twofa_required) { setNeedCode(true); toast.info("Entrez votre code d'authentification (2FA)"); return; }
      localStorage.setItem("pg_token", data.token);
      toast.success("Connexion interne réussie");
      window.location.href = data.redirect || "/app";
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail) || "Échec de connexion"); }
    finally { setSaving(false); }
  };

  const inputCls = "w-full rounded-lg border border-white/15 bg-black/40 px-3 py-2.5 text-sm text-white placeholder:text-white/30 focus:border-[#EAB308] focus:outline-none";

  return (
    <div className="min-h-screen progere-page flex items-center justify-center p-4">
      <div className="w-full max-w-md rounded-2xl border border-white/12 bg-[#0e0f13] p-8" data-testid="internal-login-page">
        <div className="mb-6 flex items-center gap-3">
          <div className="flex h-12 w-12 items-center justify-center rounded-xl border border-[#EAB308]/40 bg-[#EAB308]/10"><ShieldCheck className="w-6 h-6 text-[#EAB308]" /></div>
          <div>
            <ProgereBrand module="MASTER CENTER" size="medium" />
            <div className="text-xs uppercase tracking-widest text-white/45">Accès interne sécurisé</div>
          </div>
        </div>

        <div className="space-y-3">
          <input type="email" className={inputCls} placeholder="Courriel" value={email} onChange={(e) => setEmail(e.target.value)} disabled={needCode} data-testid="internal-email" />
          <input type="password" className={inputCls} placeholder="Mot de passe" value={password} onChange={(e) => setPassword(e.target.value)} disabled={needCode} data-testid="internal-password" />
          {needCode && (
            <div className="rounded-lg border border-[#EAB308]/30 bg-[#EAB308]/5 p-3">
              <div className="mb-2 flex items-center gap-2 text-xs text-[#EAB308]"><KeyRound className="w-3.5 h-3.5" /> Authentification à deux facteurs</div>
              <input className={inputCls} placeholder="Code 2FA ou code de récupération" value={code} onChange={(e) => setCode(e.target.value)} data-testid="internal-2fa-code" autoFocus />
            </div>
          )}
          <button onClick={submit} disabled={saving} data-testid="internal-login-submit" className="w-full rounded-lg bg-[#EAB308] px-6 py-2.5 text-sm font-bold text-black hover:bg-[#ffd45c] disabled:opacity-50">
            {saving ? "Connexion…" : needCode ? "Vérifier le code" : "Se connecter"}
          </button>
          <a href="/login" className="block text-center text-xs text-white/40 hover:text-white/70">Retour à la connexion client</a>
        </div>
      </div>
    </div>
  );
}
